import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface State {
  list: string | undefined;

  actions: {
    selectList: (list: State['list']) => void;
  };
}

const useState = create<State>()(
  persist(
    (set) => ({
      list: undefined,
      actions: {
        selectList: (list) => set({ list }),
      },
    }),
    {
      name: 'ace.workinglist',
      partialize: ({ actions: _, ...state }) => state,
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export const useSelectedWorkingList = () => useState((state) => state.list);

export const useWorkingListActions = () => useState((state) => state.actions);
